<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-shop></breadcrumb-shop>
    <!-- breadcrumb end -->
  
    <!-- shop area start -->
    <shop-area></shop-area>
    <!-- shop area end -->
  
    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script>
import BreadcrumbShop from '@/components/breadcrumb/breadcrumb-shop.vue';
import ShopArea from '@/components/shop/shop-area.vue';
import CtaArea from '@/components/cta/cta-area.vue';
  export default {
    // eslint-disable-next-line vue/multi-word-component-names 
    name: "Shop",
    components: {
      ShopArea,
      BreadcrumbShop,
      CtaArea,
    },
  };
  </script>
